import { Outlet } from "react-router-dom";
import AppUrlHandler from "@/components/auth/AppUrlHandler";
import RouteGuard from "@/components/auth/RouteGuard";
import ScrollToTop from "@/components/routing/ScrollToTop";
import HomeNav from "@/app/components/common/HomeNav";

export default function RootLayoutRoute() {
  return (
    <>
      <ScrollToTop />
      <AppUrlHandler />
      <RouteGuard>
        <Outlet />
      </RouteGuard>
      <HomeNav />
    </>
  );
}
